// Telefon kodlari: kirish va xodim qo'shish formalarida (+998 dan tashqari ham — masalan Turkiyadagi xodimlar).
// digits — kod'dan keyingi raqamlar soni.
export const PHONE_COUNTRIES = [
  { code: '+998', digits: 9,  flag: '🇺🇿' },
  { code: '+90',  digits: 10, flag: '🇹🇷' },
  { code: '+7',   digits: 10, flag: '🇷🇺' },
  { code: '+992', digits: 9,  flag: '🇹🇯' },
  { code: '+996', digits: 9,  flag: '🇰🇬' },
];

const KEY = 'phoneCountry';

export function countryOf(code) {
  return PHONE_COUNTRIES.find(c => c.code === code) || PHONE_COUNTRIES[0];
}

// To'liq raqamni (+905551112233) kod va qolgan raqamlarga ajratadi
export function splitPhone(full) {
  const s = String(full || '');
  // uzunroq kodlar oldin tekshiriladi (+998 va +99x — +9x dan oldin)
  const c = [...PHONE_COUNTRIES].sort((a, b) => b.code.length - a.code.length).find(x => s.startsWith(x.code));
  return c ? { code: c.code, rest: s.slice(c.code.length).replace(/\D/g, '') } : { code: '+998', rest: s.replace(/\D/g, '').slice(-9) };
}

export function rememberedCountry() {
  try { return countryOf(localStorage.getItem(KEY)).code; } catch { return '+998'; }
}

export function rememberCountry(code) {
  try { localStorage.setItem(KEY, code); } catch { /* ignore */ }
}
